import { calculateDistance } from '../helpers/functions.js';

export const SearchModule = {
	state: {
		geocoder: {},
		polygon: {},
		categories: [], //static, will not be mutated
		filters: {
      gradeLevel: '',
      features: {},
    },
    geocodedResults: {
    	active: false,
    	latLng: {},
    	formattedAddress: '', // user input address formatted through gmaps api
      partial_match: false,
      zero_results: false
    },
    showResultsTag: false
	},
	getters: {
		selectedFeatures: state => {
      let results = []
      for (let f in state.filters.features) {
        if (state.filters.features[f]) results.push(f)
      }
      return results
    },
    formattedGradeLevel: state => {
    	switch(state.filters.gradeLevel) {
	  		case 'preschool':
	  			return 'Preschool'
	  		case 'elementary':
	  			return 'Elementary'
	  		case 'junior_high':
	  			return 'Junior High'
	  		case 'high_school':
	  			return 'High School'
	  		case 'choice_school':
	  			return 'Choice School'
	  		default:
	  			return;
	  	}
    },
    addressSort: state => {
    	return {
    		active: state.geocodedResults.active,
    		address: state.geocodedResults.formattedAddress
    	}
    },
    ariaData: (state, getters, rootState) => {
    	let applied = state.filters.gradeLevel ? 1 : 0
    	applied += getters.selectedFeatures.length

    	let description = `Results: ${rootState.main.filteredSchools.results}, Filters applied: ${applied}, ${getters.formattedGradeLevel}`
    	getters.selectedFeatures.forEach(feature => description += `, ${feature}`)

    	if (state.geocodedResults.active) {
    		description += `. Results are sorted by distance from ${state.geocodedResults.formattedAddress}`
    	}

    	return { applied: applied, description: description }
    }
	},
	mutations: {
    toggleResultsTag(state, value) {
    	state.showResultsTag = value
    },
    updateGradeLevel(state, value) {
    	if (state.filters.gradeLevel === value) {
    		state.filters.gradeLevel = ''
    	} else {
    		state.filters.gradeLevel = value
    	}
    },
    toggleFeature(state, feature) {
      state.filters.features[feature.name] = feature.checked
    },
    resetFeatures(state) {
    	for (let f in state.filters.features) {
        state.filters.features[f] = false
      }
    },
    updateGeocodedResults(state, options) {
    	state.geocodedResults.active = options.active
    	state.geocodedResults.latLng = options.latLng
    	state.geocodedResults.formattedAddress = options.address
    }
	},
	actions: {
		basicSearch({commit, dispatch}) {
			commit('resetCompare')
			commit('toggleResultsTag', true)
			dispatch('filterSchools')
		},
		addressSearch({state, commit, dispatch}, address) {
			return new Promise((resolve, reject) => {
				dispatch('geocodeAddress', address)
					.then((geoData) => {
						commit('updateGeocodedResults', { active: true, latLng: geoData.latLng, address: geoData.address})
						commit('resetCompare')
						commit('toggleResultsTag', true)
						dispatch('filterSchools')
						resolve()
					})
					.catch(errors => reject(errors))
			})
		},
		geocodeAddress({ state, commit }, address) {
	    return new Promise(function(resolve, reject) {
	      state.geocoder.geocode({'address': address}, function(results, status) {
          let resolvedValues;
          let latLng;
          let address;
          if (status === 'OK') {
            latLng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            address = results[0].formatted_address;
            switch (true) {
              case results[0].partial_match:
                resolvedValues = {
                  latLng,
                  address,
                  partialMatch: true,
                  zeroResults: false
                }
                resolve(resolvedValues);
                break;

              case !results[0].partial_match:
                 resolvedValues = {
                  latLng,
                  address,
                  partialMatch: false,
                  zeroResults: false
                }
                resolve(resolvedValues);
                break;

              default:
                break;
            }

          }
          else if (status === 'ZERO_RESULTS') {
            latLng = new google.maps.LatLng(0, 0);
            resolvedValues = {
              latLng,
              address: "",
              partialMatch: false,
              zeroResults: true
            }
	          resolve(resolvedValues);

          } else {
	        	reject(status)
	        }
	      })
	    })
		},
		inBoundary({state, commit, dispatch}, data) {
			state.polygon.setPaths(data.polygons)
			return new Promise((resolve, reject) => {
				dispatch('geocodeAddress', data.address)
					.then((geoData) => {
						resolve({
							inBoundary: google.maps.geometry.poly.containsLocation(geoData.latLng, state.polygon) ? true : false,
							address: geoData.address
						})
					})
					.catch(errors => reject(errors))
			})
		},
		getHomeschools({state, dispatch, rootState}, data) {
			return new Promise((resolve, reject) => {
				dispatch('geocodeAddress', data.address)
					.then((geoData) => {
						let homeschools = []
						rootState.main.schools.forEach((school) => {
							for (let i = 0; i < school.polygons.length; i++) {
								state.polygon.setPaths(school.polygons[i])
								if (google.maps.geometry.poly.containsLocation(geoData.latLng, state.polygon)) {
									school.showInfoWindow = false
									school.showPolygons = false
				      		homeschools.push(school)
				      		break
				      	}
							}
						})
						//orders homeschools: elem, junior, high. This works because site codes get bigger as grade levels increase
						homeschools.sort((a, b) => { return a.id - b.id })
						resolve({ 'userData': geoData, 'homeschools': homeschools })
					})
					.catch(errors => reject(errors))
			})
		},
		filterSchools({state, commit, dispatch, getters, rootState}) {

			let results = { normal: [], choice: [], results: 0 }

	    rootState.main.schools.forEach(function(e) {

		    let match = true;

		    //check grade level
		    if (state.filters.gradeLevel !== '' && e[state.filters.gradeLevel] === 0) {
		      match = false
		    }

		    //check features
		    if (e.features.length > 0) {

		    	let schoolFeatures = []
		      e.features.map(feature => schoolFeatures.push(feature.name))

		      getters.selectedFeatures.forEach((e) => {
		      	if (!schoolFeatures.includes(e)) {
		      		match = false
		      	}
		      })
		    } else if (getters.selectedFeatures.length > 0) { // if there are selected features and school has no features
	    		match = false
		    }

		    //check for address filter
		    if (state.geocodedResults.active) {
		    	e.distance = calculateDistance(state.geocodedResults.latLng.lat(), state.geocodedResults.latLng.lng(), e.latitude, e.longitude).toFixed(2)
		    }

		    if (match) {
		    	results.results++
		    	e.types.includes('choice') ? results.choice.push(e) : results.normal.push(e)
		    }
		  })

	    /*
				sort schools by distance if user provided address, otherwise sort alphabetically
	    */
		  if (state.geocodedResults.active) {
		  	results.normal.sort((a, b) => a.distance - b.distance)
		  	results.choice.sort((a, b) => a.distance - b.distance)
		  } else {
			  results.normal.sort(function(a, b) {
			  	let s1 = a.name.toLowerCase().replace(/\s/g, '')
			  	let s2 = b.name.toLowerCase().replace(/\s/g, '')
			  	if (s1 < s2) { return -1 }
			  	if (s1 > s2) { return 1 }
		  		return 0
			  })
			  results.choice.sort(function(a, b) {
			  	let s1 = a.name.toLowerCase().replace(/\s/g, '')
			  	let s2 = b.name.toLowerCase().replace(/\s/g, '')
			  	if (s1 < s2) { return -1 }
			  	if (s1 > s2) { return 1 }
		  		return 0
			  })
			}

		  commit('updateFilteredSchools', results)
		}
	} // end actions

} // end search module
